import { useQuery } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import type { GetEventContributorsDto } from '@/types/dtos/contributors/response/get-event-contributors.dto.ts';

export const GET_EVENT_CONTRIBUTORS_QUERY_KEY = 'get-event-contributors';

export const useGetEventContributorsQuery = (eventId?: string, opts?: { enabled?: boolean }) => {
  const { getToken } = useAuth();

  return useQuery({
    queryKey: [GET_EVENT_CONTRIBUTORS_QUERY_KEY, eventId],
    queryFn: async () => {
      const token = await getToken();
      return getEventContributors({ eventId: eventId!, token: token ?? '' });
    },
    enabled: !!eventId && (opts?.enabled ?? true),
  });
};

const getEventContributors = async ({
  eventId,
  token,
}: {
  eventId: string;
  token: string;
}): Promise<GetEventContributorsDto> => {
  const url = `${import.meta.env.VITE_API_URL}/contributors/event/${eventId}`;
  return sendJSONRequest({ url, method: METHOD.GET, token });
};
